import { createFileRoute } from "@tanstack/react-router";
import { NewEmailForm } from "../-components/NewEmailForm";
import { ContextUser } from "@/lib/utils";

export const Route = createFileRoute("/_dashboard/emails/system/new-email")({
  component: RouteComponent,
  loader: async ({ context }) => {
    return { crumb: "New system email", user: context.user as ContextUser | null | undefined };
  },
});

function RouteComponent() {
  const { user } = Route.useLoaderData();
  return <NewEmailForm scope="system" user={user} />;
}
